/**
 * Quiet Hours motion vocabulary.
 *
 * This is deliberately an *inversion* of the game-feel motion language
 * used in `variants/reading-room/motion.ts`. Where games want stiff
 * springs that "land like a card on a desk" (stiffness 220+, damping
 * ~22, mass 1), meditation wants slow, smooth, overshoot-free
 * deceleration. Nothing should bounce. Nothing should snap.
 *
 * Spring stiffness ~60 and damping ~18 produces a soft, critically-
 * damped landing: things drift into place. No overshoot.
 *
 * Durations live in the 800–1600ms range. No <300ms staggers.
 */

/** Drift-into-place spring — used for hub category cards, session-config
 *  panels, anything that "arrives." */
export const driftSpring = {
  type: 'spring' as const,
  stiffness: 60,
  damping: 18,
  mass: 1,
};

/** A slower, calmer spring for the active session — even less responsive
 *  so changes during a session never feel like UI movement. */
export const settleSpring = {
  type: 'spring' as const,
  stiffness: 45,
  damping: 20,
  mass: 1,
};

/** Stagger between consecutive cards/panels (seconds). At 320ms, three
 *  cards take ~960ms to arrive — slow enough to read as breath, not as
 *  a snappy cascade. */
export const SLOW_STAGGER_S = 0.32;

/** Standard fade timings for non-spring transitions. */
export const FADE = {
  in: { duration: 1.2, ease: [0.4, 0, 0.2, 1] as [number, number, number, number] },
  out: { duration: 1.6, ease: [0.4, 0, 0.2, 1] as [number, number, number, number] },
  slow: { duration: 2.0, ease: [0.4, 0, 0.2, 1] as [number, number, number, number] },
} as const;
